import { render, staticRenderFns } from "./ngoForm.vue?vue&type=template&id=1ad6ea56&scoped=true&"
import script from "./ngoForm.vue?vue&type=script&lang=js&"
export * from "./ngoForm.vue?vue&type=script&lang=js&"
import style0 from "./ngoForm.vue?vue&type=style&index=0&id=1ad6ea56&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ad6ea56",
  null
  
)

export default component.exports